/**
 * Dropdown options for the inventory management UI.
 *
 * These mirror the choice fields on the backend models
 * (`server/fastlane/location/models.py`). They are stable enums, so we keep
 * them as frontend constants rather than fetching them.
 */

export interface ISelectOption {
	label: string;
	value: string;
}

/** RackLocation.storage_type / Location.type — STORAGE_TYPE_CHOICES */
export const STORAGE_TYPES: ISelectOption[] = [
	{ label: 'Shared Bins', value: 'SHARED_BINS' },
	{ label: 'Individual Slots', value: 'INDIVIDUAL_SLOTS' },
	{ label: 'Shared Shelves', value: 'SHARED_SHELVES' },
	{ label: 'Overflow', value: 'OVERFLOW' },
	{ label: 'Shop Floor', value: 'SHOP_FLOOR' },
	{ label: 'Heavy Rack', value: 'HEAVY_RACK' },
];

/** ShelfLocation.material_type — MATERIAL_TYPE_CHOICES */
export const MATERIAL_TYPES: ISelectOption[] = [
	{ label: 'Aluminum', value: 'Aluminum' },
	{ label: 'Stainless Steel', value: 'Stainless Steel' },
	{ label: 'Steel', value: 'Steel' },
	{ label: 'Other', value: 'Other' },
];

/** ShelfLocation.shape_category — MATERIAL_SHAPE_CHOICES */
export const SHAPE_CATEGORIES: ISelectOption[] = [
	{ label: 'Flats', value: 'Flats' },
	{ label: 'Rounds', value: 'Rounds' },
];

/** ShelfLocation.production_method_type — METHODS_CHOICES */
export const PRODUCTION_METHODS: ISelectOption[] = [
	{ label: 'Swiss', value: 'Swiss' },
	{ label: 'FastLane', value: 'FastLane' },
];

/** Storage types whose locations are dimensioned by volume. */
export const VOLUME_TYPES = ['SHARED_BINS'];
/** Storage types whose locations are dimensioned by width/height. */
export const SLOT_TYPES = ['INDIVIDUAL_SLOTS'];
/** Storage types whose capacity is the shelf weight (no per-location dims). */
export const WEIGHT_TYPES = ['SHARED_SHELVES'];

export const STORAGE_TYPE_LABELS: Record<string, string> = STORAGE_TYPES.reduce(
	(acc, { label, value }) => ({ ...acc, [value]: label }),
	{},
);
